module.exports = __webpack_public_path__ + "img/NinaBalzer_140x140.2d5f3b03.jpg";